import { StatusCodes } from "http-status-codes"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import { DiMaDetailsHeaderProps } from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { renderDetailsTabWithGrid } from "../../../../components/Helpers"
import { UserContext } from "../../../../context/UserContext"
import { ApplicationPropertyGet } from "../../../../models/ApplicationProperty"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { ApplicationPropertyDetails } from "./details_tab/ApplicationPropertyDetails"

export function ApplicationPropertyContainer() {
  const { applicationId, propertyName } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()
  const returnURL = `/applications/${applicationId}#properties`

  const { activeTab, handleTabChange } = useHashTab("details")

  const [property, setProperty] = useState<ApplicationPropertyGet>()

  useEffect(() => {
    if (applicationId && propertyName) {
      digitalManagerApi
        .get<ApplicationPropertyGet>(
          `/applications/${applicationId}/properties/${propertyName}`
        )
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setProperty(res.data)
          }
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [applicationId, navigate, propertyName, returnURL])

  if (!applicationId) {
    return <Navigate to="/applications" />
  }
  if (!propertyName) {
    return <Navigate to={returnURL} />
  }
  if (!property || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: property.name,
    label: "Property Type",
    subtitle: property.type,
    hideCopyToClipboard: true,
  }

  return renderDetailsTabWithGrid({
    detailsHeaderProps,
    activeTab,
    handleTabChange,
    DetailsComponent: ApplicationPropertyDetails,
    detailsComponentProps: {
      property,
      applicationId,
      user,
      setProperty,
    },
  })
}
